"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectArgs = void 0;
class EffectArgs {
    constructor(__type, __typeName, name, harmful) {
        this.__type = __type;
        this.__typeName = __typeName;
        this.name = name;
        this.harmful = harmful;
    }
}
exports.EffectArgs = EffectArgs;
